var map = {
	"./01__fire_anim.mkv": 4180,
	"./02_broom.png": 1736,
	"./02_whitch_hat.png": 7646,
	"./04_pumpkin.png": 9465,
	"./06_skeleton.png": 3072,
	"./07_assemble.png": 7695,
	"./10_cauldron.png": 2038,
	"./11_devil.png": 6088,
	"./12_moon_wond_anim.mkv": 7243,
	"./14_hole.png": 7512,
	"./15_mirror_anim.mkv": 8295,
	"./16_moon.png": 2653,
	"./17_grave.png": 8941,
	"./18_corn.png": 9774,
	"./19_goat.png": 7050,
	"./20_spider.png": 6942,
	"./21_cabin.png": 9667,
	"./22_frog.png": 3042,
	"./23_sword.png": 5807,
	"./24_trap.png": 5446,
	"./25_death.png": 5503,
	"./26_gragouille.png": 1773,
	"./27_cat.png": 143,
	"./28_mushroom.png": 9249,
	"./29_map.png": 6429,
	"./30_ghost_anim.mkv": 3256,
	"./31_candle.png": 5128,
	"./36_bat_signal.png": 7969,
	"./37_potion.png": 933,
	"./38_lantern.png": 9306,
	"./39_magical_hunt.png": 203,
	"./40_coin_coin.png": 1744,
	"./41_dragon.png": 6349,
	"./42_misha_hot_dog.png": 1177,
	"./43_saloon.png": 6515,
	"./44_she_ra_sword.png": 3533,
	"./45_sun_eat_cloud_2.png": 1719,
	"./46_snowman.png": 1530,
	"./47_vampire.png": 5308,
	"./48_sword_surfing.png": 4685,
	"./49_toothless.png": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7394;